const _zairyuuStatus=[
    {"name":"留学","name_en":"Student visa"},
    {"name":"技能実習","name_en":"Technical intern training visa"},
    {"name":"高度専門職","name_en":"Highly skilled professional visa"},
    {"name":"特定技能","name_en":"Specified skilled worker visa"},
    {"name":"技術・人文知識・国際業務","name_en":"Engineer / Specialist in Humanities / Int'lServices"},
    {"name":"家族滞在","name_en":"Family stay visa"},
    {"name":"永住者","name_en":"Permanent resident visa"},
    {"name":"日本人の配偶者","name_en":"Spouse or Child of Japanese National"},
    {"name":"その他","name_en":"Other"}
];

export default {
    data () {
      return {
        zairyuu: _zairyuuStatus,
      }
    }
  }
  
  